import React from 'react';
import {Button, Card, Form, Input, message} from 'antd';
import {Auth} from "aws-amplify";
import {useAppContext} from "../libs/ContextLibs";
import ForgotPassword from "../layout/ForgotPassword";

const queryString = require('query-string');

const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 9,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 5,
        span: 20,
    },
};

export default function Login(props) {
    const params = queryString.parse(props.location.search);
    const reset = params.reset === "true";
    const token = params.token;
    const step = parseInt(params.step) ;
    const {setIsAuthenticated, setUser} = useAppContext();

    async function onFinish(values) {
        try {
            await Auth.signIn(values.username, values.password).then(async ()=>{
                setIsAuthenticated(true);
                setUser(await Auth.currentUserInfo());
            });

        } catch (e) {
            message.error(e.message);
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <>
            <div style={{background: '#fff', padding: 20, minHeight: '100%'}}>
                <div className='login-page'>
                    <div className="content">
                        <img src="/niq-lg-rgb-pos.png" width="300px" alt="Nielsen IQ"/>
                        <Card bordered={false} style={{width: 1000}}>
                            <Form
                                {...layout}
                                name="basic"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            >
                                <Form.Item
                                    label="Email"
                                    name="username"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your username!',
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>

                                <Form.Item
                                    label="Password"
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                >
                                    <Input.Password/>
                                </Form.Item>

                                <Form.Item {...tailLayout}>

                                    <ForgotPassword reset={reset} code={token} step={step}/>
                                    <Button type="primary" size="large" shape="round" htmlType="submit">
                                        Login
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </div>

                </div>
            </div>
        </>

    );
};
